const validGoogleSymbols = [
    'accessible',
    'account_tree',
    'add',
    'airline_seat_legroom_extra',
    'airline_seat_legroom_normal',
    'airline_seat_legroom_reduced',
    'airline_seat_recline_normal',
    'airport_shuttle',
    'api',
    'app_registration',
    'apps',
    'apps_outage',
    'architecture',
    'arrow_back',
    'arrow_downward',
    'arrow_drop_down',
    'arrow_forward',
    'arrow_upward',
    'article',
    'assessment',
    'assignment_add',
    'attach_money',
    'attractions',
    'auto_transmission',
    'beach_access',
    'bed',
    'bookmark',
    'bookmark_add',
    'box_edit',
    'bug_report',
    'build',
    'business_center',
    'calendar_clock',
    'calendar_month',
    'call',
    'cancel',
    'car_crash',
    'carry_on_bag',
    'casino',
    'chat',
    'check',
    'check_box',
    'check_box_outline_blank',
    'check_circle',
    'check_indeterminate_small',
    'checked_bag',
    'chevron_left',
    'chevron_right',
    'chronic',
    'close',
    'closed_caption',
    'closed_caption_off',
    'content_copy',
    'currency_exchange',
    'cycle',
    'dashboard',
    'database',
    'database_search',
    'database_upload',
    'date_range',
    'delete',
    'delete_sweep',
    'deployed_code',
    'deployed_code_account',
    'deployed_code_alert',
    'deployed_code_history',
    'deployed_code_update',
    "description",
    'developer_board',
    'directions_boat',
    'directions_car',
    'distance',
    'domain',
    'eco',
    'edit',
    'editor_choice',
    'email',
    'error',
    'expand_less',
    'expand_more',
    'explore',
    'family_restroom',
    'favorite',
    'file_copy',
    'first_page',
    'fitness_center',
    'flash_on',
    'flight',
    'flight_takeoff',
    'fork_spoon',
    'format_quote',
    'free_cancellation',
    'fullscreen',
    'fullscreen_exit',
    'group',
    'groups',
    'heart_plus',
    'help',
    'history',
    'home',
    'home_work',
    'hot_tub',
    'hotel',
    'hub',
    'id_card',
    'image',
    'info',
    'integration_instructions',
    'key',
    'keyboard_arrow_down',
    'kitchen',
    'last_page',
    'layers',
    'link',
    'local_bar',
    'local_cafe',
    'local_dining',
    'local_parking',
    'local_see',
    'local_taxi',
    'location_city',
    'location_on',
    'lock',
    'login',
    'logout',
    'luggage',
    'mail',
    'manage_accounts',
    'medical_services',
    'menu',
    'menu_open',
    'mic',
    'monitoring',
    'moon_stars',
    'motion_photos_auto',
    'my_location',
    'network_node',
    'north',
    'open_in_new',
    'oven',
    'paid',
    'pause',
    'person',
    'person_check',
    'pets',
    'photo_library',
    'pin_drop',
    'play_arrow',
    'policy',
    'pool',
    'priority_high',
    'progress_activity',
    'question_mark',
    'radio_button_checked',
    'radio_button_unchecked',
    'refresh',
    'remove',
    'restaurant',
    'road',
    'route',
    'schedule',
    'search',
    'security',
    'sell',
    'settings',
    'shoppingmode',
    'smoke_free',
    'south',
    'spa',
    'star',
    'swap_horiz',
    'sync',
    'task_alt',
    'team_dashboard',
    'thumb_down',
    'thumb_up',
    'time_to_leave',
    'track_changes',
    'travel_luggage_and_bags',
    'tune',
    'unfold_more',
    'verified',
    'verified_user',
    'view_carousel',
    'vital_signs',
    'warning',
    'webhook',
    'widgets',
    'wifi',
    'work',
    'zoom_in',
    'zoom_out'
];
export { validGoogleSymbols };
